import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Card,
  Spinner,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "react-toastify";

export default function Login() {
  // const navigate = useNavigate();
  const { login } = useAuth();

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({ user_name: "", password: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await login(formData.user_name, formData.password);

      if (!res.success) {
        toast.error(res.error || "Login failed. Please try again.");
        console.error("Login error:", res);
        return;
      }

      setTimeout(() => {
        setLoading(false);
        toast.success("Login successful");
      }, 1000);

      // Option A: If backend sends redirect link
      setTimeout(() => {
        if (res.link) {
          window.location.href = res.link;
        }
      }, 1500);
    } catch (err) {
      setLoading(false);
      console.error("Unexpected login error:", err);
      toast.error("Something went wrong. Please try again.");
    } 
  };

  // const handleLogin = async (e) => {
  //   console.log(e);
  //   setLoading(true);
  //   e.preventDefault();
  //   console.log(formData);

  //   // navigate("/dashboard");
  //   // return;
  //   const res = await login(formData.user_name, formData.password);

  //   if (!res.success) {
  //     console.log(res);
  //     setLoading(false);

  //     toast.error(res.error);
  //   } else {
  //     // navigate("/dashboard");
  //     console.log("suceess");
  //     toast.success("login successful");

  //     //
  //     setTimeout(() => {
  //       setLoading(false);
  //       window.location.href = res.link;
  //     }, 400);
  //   }
  // };

  return (
    <div
      style={{
        background: "linear-gradient(to right, #1e3c72, #2a5298)",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Container>
        <Row className="justify-content-center">
          <Col md={5}>
            <Card
              className="shadow-lg border-0"
              style={{
                backdropFilter: "blur(10px)",
                background: "rgba(255,255,255,0.85)",
                borderRadius: "15px",
              }}
            >
              <Card.Body className="p-4">
                <h2 className="text-center mb-4 fw-bold text-primary">Login</h2>
                <Form onSubmit={(e) => handleLogin(e)}>
                  <Form.Group className="mb-3" controlId="form_user_name">
                    <Form.Label>Username </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter User Name"
                      name="user_name"
                      value={formData.user_name}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-4" controlId="formPassword">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Enter password"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Button
                    variant="primary"
                    type="submit"
                    className="w-100 py-2 fw-semibold"
                    disabled={loading}
                  >
                    {loading ? <Spinner size="sm" /> : "Login"}
                  </Button>
                </Form>
                <div className="text-center mt-3">
                  <small className="text-muted">
                    <Link to={"/"}>Visit Site</Link>
                  </small>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
